<template>
<m-pageframe
    title="Calendly Event Types"
>
<v-container
    fluid
>

    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
    >
    </v-text-field>

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
    
        <template v-slot:item.action="{ item }">
            <v-menu 
                bottom 
                offset-y  
            >
            
            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical-circle-outline
                </v-icon>
                    
            </template>
            
            <v-list>
                <v-list-item
                    v-on:click="onClickSetPurpose(item)"
                >
                    <v-list-item-title>Set purpose...</v-list-item-title>
                </v-list-item>
            
            </v-list>
            
            </v-menu> 
        </template>
    
    </v-data-table>

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');
export default {
    data() {
        return {
            full_text: null,
            headers: [
                { text: 'Owner', value: 'owner_label'},
                { text: 'Name', value: 'event_type_name'},
                { text: 'Scheduling URL', value: 'event_type_scheduling_url'},
                { text: 'Purpose', value: 'purpose'},
                { text: 'Action', value: 'action'},
            ],
            results: [],
        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/calendly/event-types',
            
                'params' : {
                        'full_text': this.full_text,
                    },
            
                'on_success': (data) => {
                        this.results = data.results;
                    },
            
                'on_error': 'Unable to list event types',
            });
        },
        
        onClickSetPurpose(item)
        {
            this.$rc.pick({
                'title': 'Select purpose',
                'content_before': null,
                'content_after': null,
            
                'choices': this.$rc.enumChoices('event_purpose',true),
            
                'multiple': false,
                'type': 'select',
                'select_label': 'Choose One',
                'initial_value': null,
            
                'on_ok': (value) => {

                    item.purpose = value;

                    this.$rc.rest({
                        'spinner': false,
                        'endpoint': 'PUT: /api/v1/calendly/event-types',
                    
                        'params' : item,
                    
                        'on_success': (data) => {
                                this.doUpdate();
                            },
                    
                        'on_error': 'Unable to modify event type',
                    });
                },
            
                'on_cancel': () => {}
            });
        },
    },
}
</script>

<style lang="scss" scoped>
</style>
